import React, { useState, useEffect } from 'react';

import './Devices.assign.scss';
import Input from '../forms/inputs/Input';
import gqlSchemaLibrary from '../services/graphql.schemas';
import {useQuery, useMutation, useLazyQuery} from '@apollo/client';
import Button from '../forms/buttons/Button';
import ButtonIcon from '../forms/buttons/Button.icon';
import GraphQlClient from '../services/graphql';
import { Link } from 'react-router-dom';
import {getDateFormat} from "../utils/date";
import {PatientAvatar} from "../visuals/Patient.avatar";
import {useTranslation} from "react-i18next";
import Select from "../forms/inputs/Select";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function DevicesBaseAssign({ currentOrg, deviceToAssign, onSucces, onClose, isKit }) {
    const {t} = useTranslation(['devices','common','users']);
    const [search, setSearch] = useState('');
    const [patientselected, setSelection] = useState(null);
    const [confirmed, setConfirmed] = useState(false);
    const [patients, setPatients] = useState({ getUserPatients: [] });
    const [selectHub, setSelectHub] = useState(null);
    const [hubs, setHubs] = useState([]);
    const [onAction, setOnAction] = useState(false);

    useEffect(() => {
        setSelectHub(null);
        if (patientselected) {
            getDevices({
                variables: {
                    deviceSubtype: 'BioHub'
                }
            })
        } else {
            setHubs([]);
        }
    }, [patientselected])

    const [currentUser] = useState(GraphQlClient.userSubject.value)

    useQuery(gqlSchemaLibrary.patients.getPersonByOrganization, {
        onCompleted: (onPatients) => {
            console.log('[Device Assign] User Patients: ', onPatients);
            if (onPatients.getPersonByOrganization) {
                setPatients({ getUserPatients: onPatients.getPersonByOrganization.filter((p) => p.programId) })
            }
        },
        fetchPolicy: 'cache-and-network'
    });

    const [getDevices] = useLazyQuery(gqlSchemaLibrary.devices.peripherial.getPeripherialsByOrg, {
        onCompleted: (onDevices) => {
            if (onDevices.getPeripherialsByOrg) {
                const _assignedHubs = onDevices.getPeripherialsByOrg.filter((d) => d.patientId && d.patientId === patientselected._id);
                const _availableHubs = onDevices.getPeripherialsByOrg.filter((d) => !d.patientId);
                setHubs(_assignedHubs.concat(_availableHubs));
            }
        },
        fetchPolicy: 'cache-and-network'
    });

    const [assigningPeripheralToPatient] = useMutation(gqlSchemaLibrary.devices.peripherial.mutation.assignPeripheralToPatient, {
        onCompleted: ({ assignPeripheralToPatient }) => {
            if (assignPeripheralToPatient) {
                setConfirmed(true)
            }
            setOnAction(false);
        },
        onError: (error) => {
            setOnAction(false);
        }
    });

    const [assignKitToPatient] = useMutation(gqlSchemaLibrary.kits.mutation.assignKitToPatient, {
        onCompleted: ({ assignKitToPatient }) => {
            setOnAction(false);
            if (assignKitToPatient) {
                setConfirmed(true)
            }
        },
        onError: (error) => {
            setOnAction(false);
        }
    });

    const patientsFiltered = !!search ? patients.getUserPatients.filter(up => {
        const _search = search.toLowerCase();
        return up.user.bio.lastname.toLowerCase().includes(_search) || up.user.bio.firstname.toLowerCase().includes(_search)
    }) : patients.getUserPatients;

    const selectPatient = (patient) => {
        return () => {
            AuditTrail.sendLog(PAGES.DEVICE_TYPE_LIST, {tag: 'button', event: 'onClick', action: 'button modal selected patient', patient_id: patient? patient._id : null});
            setSelection(patient);
        }
    }

    const confirmPatient = () => {
        if (onAction) {
            return;
        }
        setOnAction(true);
        AuditTrail.sendLog(PAGES.DEVICE_TYPE_LIST, {tag: 'button', event: 'onClick', action: 'button modal added device', patient_id: patientselected? patientselected._id : null});
        if (isKit) {
            assignKitToPatient({
                variables: {
                    kitId: deviceToAssign.kitId,
                    patientId: patientselected._id
                }
            });
        } else {
            assigningPeripheralToPatient({
                variables: {
                    relationship: {
                        patientId: patientselected._id,
                        deviceId: deviceToAssign.deviceId,
                        docId: deviceToAssign._id,
                        requiredDevices: selectHub? [selectHub] : []
                    }
                }
            });
        }
    }

    const testDevice = () => {
        onSucces(true);
    }

    const getDeviceOptions = () => {
        return hubs.map((d) => {
            const label = !!d.patientId? 'Currently Assigned' : 'New';
            return {
                label: d.deviceSubtype + ' - ' + d.deviceId + ' - ' + label,
                value: d.deviceId
            };
        })
    }

    const onSelectDevice = (d) => {
        setSelectHub(d);
    }

    const requiredDevice = () => {
        const bioDevice = deviceToAssign.deviceSubtype === 'BioButton' || deviceToAssign.deviceSubtype === 'BioSticker' || deviceToAssign.deviceSubtype === 'Rechargeable BioButton';
        return bioDevice && patientselected.requiredDevices && patientselected.requiredDevices.length
    }

    const disableDoneButton = () => {
        return onAction || !currentUser.userRoles.devicesAssign.edit || !isKit && deviceToAssign.kitId || (requiredDevice() && !selectHub);
    }

    const _onClose = () => {
        AuditTrail.sendLog(PAGES.DEVICE_TYPE_LIST, {tag: 'modal', event: 'closeModal', action: 'button close modal'});
        onClose();
    }

    const renderConfirm = () => {
        return (
            <>
                <div className="_confirmation">
                    <div className="__KitAssignBody">
                        <div className="__KitAssignBodyPatientBio">
                            <div className="_BioDisplay">
                                <PatientAvatar bio={patientselected.user.bio} small={true} />
                                <div className="__BioDisplayName">
                                    <h3>
                                        {patientselected.user.bio.lastname}, {patientselected.user.bio.firstname}
                                    </h3>
                                    <div className="__BioDisplayData">
                                        <p>
                                            {patientselected.user.bio.gender}
                                        </p>
                                        <p className="centered">
                                            {Math.floor((Date.now() - patientselected.dateOfBirth) / (1000 * 60 * 60 * 24 * 365))} {t('users:yo')}
                                            </p>
                                        <p>
                                            {t('users:dob')} {getDateFormat(currentOrg, patientselected.dateOfBirth, 'short')}
                                        </p>
                                    </div>
                                </div>
                                <svg className="icon-edit" onClick={selectPatient(null)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.8281 0C19.3164 0 18.8046 0.195437 18.4141 0.585938L16 3L21 8L23.4141 5.58594C24.1951 4.80494 24.1951 3.53881 23.4141 2.75781L21.2422 0.585938C20.8517 0.195437 20.3399 0 19.8281 0ZM14 5L2.25977 16.7402C2.25977 16.7402 3.17753 16.658 3.51953 17C3.86153 17.342 3.58 19.58 4 20C4.42 20.42 6.64389 20.1244 6.96289 20.4434C7.28189 20.7624 7.25977 21.7402 7.25977 21.7402L19 10L14 5ZM1 20L0.0566406 22.6719C0.0195554 22.7773 0.000409835 22.8882 0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24C1.11177 23.9996 1.22268 23.9804 1.32812 23.9434C1.33139 23.9421 1.33464 23.9408 1.33789 23.9395L1.36328 23.9316C1.36524 23.9303 1.36719 23.929 1.36914 23.9277L4 23L2.5 21.5L1 20Z" fill="#007CB8"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    !isKit && deviceToAssign.kitId ?
                        <div className={`_kitWarning`}>
                            <i className="material-icons">warning</i>
                            <p>
                                {t('assign-text-3')} <Link to={`/programs/${patientselected.programId ? patientselected.programId : ''}/participants`}>{t('assign-text-4')}</Link>
                            </p>
                        </div>
                    : ''
                }
                {
                    requiredDevice() ?
                        <div className="_requiredDevices">
                            <span className="_label">
                                This participant requires a Hub in order to assign this device.
                            </span>
                            <div className="_options">
                                <span className="_optionLabel">
                                    Select Hub
                                </span>
                                    <Select error={false} value={selectHub} onChange={onSelectDevice} label=""
                                            placeholder={'Available Hubs'} options={getDeviceOptions()}/>
                                </div>
                            </div> : ''
                }
                <div className={`_success ${confirmed ? 'confirmed' : ''}`}>
                    <div className="_successContainer">
                        <div className="_icon">
                            <ButtonIcon className="success" size={46}>
                                <i className="material-icons">
                                    check
                                </i>
                            </ButtonIcon>
                        </div>
                        <h3>
                            { isKit? t('kit')+' ' + deviceToAssign.kitId : deviceToAssign.deviceSubtype + ' ' + deviceToAssign.deviceId }
                        </h3>
                        <h3 className="msg">Successully assigned</h3>
                    </div>
                </div>
                <div className="_actions">
                    <Button className="tertiary" handleClick={_onClose}>
                        {confirmed ? t('common:close') : t('common:cancel')}
                    </Button>
                    {
                        !confirmed ?
                            <Button className="primary" handleClick={confirmPatient} disabled={disableDoneButton()}>
                                {t('assign')}
                            </Button>
                            :
                            <Button className="primary" handleClick={testDevice}>
                                {t('common:finish')}
                            </Button>
                    }
                </div>
            </>
        )
    }

    return (
        <div id="DevicesBaseAssign">
            <div className="_deviceInfo">
                <h3>{t('assign')} { isKit? t('kit-capitalize') : deviceToAssign.deviceSubtype }</h3>
                <div className="deviceType">
                    <p><b>{isKit? t('kit-capitalize') : t('device')} {t('id').toUpperCase()}:
                    </b> {isKit? deviceToAssign.kitId : deviceToAssign.deviceId}</p>
                </div>
                {
                    patientselected? '' :
                        <div className="patientSearch">
                            <Input onChange={setSearch} label={t('assign-text-1')+' '+(isKit? t('kit') : t('device'))+' ' +t('assignment')} value={search} placeholder={t('search-participant')} event={PAGES.DEVICE_TYPE_LIST} />
                        </div>
                }
            </div>
            {
                patientselected? renderConfirm() :
                    <div className="_patientOptions">
                        <div className="_patOption header">
                            <div className="_optBio">
                                <p>{patientsFiltered.length} {t('common:results')} {search ? `${t('for')} ${search}` : ''}</p>
                                <p>{t('users:age')}</p>
                                <p className="center">{t('users:dob')}</p>
                            </div>
                        </div>
                        {patientsFiltered.map((patient) => (
                            <div key={patient._id} className="_patOption" onClick={selectPatient(patient)}>
                                <div className="_optBio">
                                    <p>{patient.user.bio.lastname}, {patient.user.bio.firstname}</p>
                                    <p className="small">{Math.floor((Date.now() - patient.dateOfBirth) / (1000 * 60 * 60 * 24 * 365))} {patient.user.bio.gender}</p>
                                    <p className="small">{getDateFormat(currentOrg, patient.dateOfBirth, 'short')}</p>
                                </div>
                            </div>
                        ))}
                    </div>
            }
        </div>
    )
}

export default DevicesBaseAssign;
